var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4336 16.4123V15.8947C10.4336 14.6145 11.317 13.5656 12.575 13.2559L27.9986 9.22905C28.26 9.16075 28.5339 9.15198 28.7993 9.20343C29.0647 9.25488 29.3145 9.36517 29.5293 9.52579C29.7442 9.68641 29.9184 9.89307 30.0385 10.1298C30.1586 10.3666 30.2214 10.6271 30.2221 10.8914V12.7892",
    stroke: "#04DB8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2225 23.1359V30.0371C30.2225 31.237 29.4336 32.2446 28.2789 32.625L26.3354 33.3151C24.0474 34.0673 21.7417 32.4162 21.7417 30.0371C21.7364 29.4259 21.9304 28.829 22.2957 28.3327C22.661 27.8364 23.1786 27.4665 23.7735 27.2766L28.2789 25.7109C29.4336 25.3313 30.2225 24.3358 30.2225 23.1359ZM30.2225 23.1359V2.61014C30.2218 2.47806 30.1902 2.3479 30.1299 2.22966C30.0696 2.11143 29.9823 2.00829 29.8748 1.9282C29.7672 1.8481 29.6423 1.79319 29.5096 1.76769C29.3769 1.7422 29.24 1.74679 29.1093 1.78113L11.494 6.40577C11.1868 6.49051 10.9166 6.67151 10.725 6.92091C10.5335 7.1703 10.4312 7.47427 10.4339 7.786V27.2818M10.4339 27.2818C10.4339 28.4817 9.64503 29.4901 8.49041 29.8697L3.89664 31.4225C2.67046 31.8262 1.95312 32.9079 1.95312 34.1829C1.95312 36.5621 4.29595 38.1985 6.54689 37.461L8.49041 36.7709C9.64503 36.3913 10.4339 35.3837 10.4339 34.1829V27.2818Z",
    stroke: "#04DB8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteImg);
export default __webpack_public_path__ + "static/media/NoteImg.3ed20e1b4f49719f3c489d4775731839.svg";
export { ForwardRef as ReactComponent };